import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';

export default class BillOfProcessFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.billOfProcessNumber = '';
		this.billOfProcessPartTypeId  = '';
		this.billOfProcessPartTypeCode = '';
		this.partNumberId  = '';
		this.partNumberPartNumber = '';
		this.partName = '';
		this.nextProcessId  = '';
		this.nextProcessName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			billOfProcessNumber : '0',
			billOfProcessPartTypeId : '0',
			billOfProcessPartTypeCode : '0',
			partNumberId : '0',
			partNumberPartNumber : '0',
			partName : '0',
			nextProcessId : '0',
			nextProcessName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}